import { useEffect, useState } from "react";

/**
 * O valor, só depois de `ms` sem mudar.
 *
 * A busca vai ao servidor a cada consulta: sem esperar, digitar "coração" faria sete idas à rede, e as
 * seis primeiras seriam jogadas fora.
 */
export function useAtraso<T>(valor: T, ms: number): T {
  const [atrasado, setAtrasado] = useState(valor);
  useEffect(() => {
    const t = setTimeout(() => setAtrasado(valor), ms);
    return () => clearTimeout(t);
  }, [valor, ms]);
  return atrasado;
}
